
import { Link } from '@tanstack/react-router';
import { Phone, Camera, ChevronRight } from 'lucide-react';
import { WhatsAppIcon } from '../WhatsAppIcon';
import { menuItems } from './Header';
import { trackWhatsAppClick } from '@/lib/gtm';

export const Footer = () => {
  const whatsappUrl = "https://wa.me/5521992698354?text=Ol%C3%A1%2C%20tudo%20bem%3F%20Estava%20no%20site%20e%20preciso%20de%20atendimento.";

  return (
    <footer id="contato" className="bg-[#2c2c2c] text-white pt-24 pb-12 px-6">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-20 text-center md:text-left">
          <div>
            <div className="flex items-center justify-center md:justify-start gap-2 mb-8">
              <img src="/logo.png" alt="STOP SOM Logo" width="220" height="56" loading="lazy" className="h-14 w-auto object-contain brightness-0 invert" />
            </div>
            <p className="text-gray-400 font-normal leading-relaxed">Excelência em janelas acústicas e esquadrias sob medida para reduzir ruídos e melhorar o conforto de ambientes em todo o Rio de Janeiro.</p>
          </div>
          <div>
            <h4 className="font-bold text-lg mb-8 uppercase tracking-wider text-accent">Links Rápidos</h4>
            <ul className="space-y-4">
              {menuItems.map(item => (
                <li key={item.label}>
                  <Link to={item.href} className="text-gray-400 font-normal hover:text-white transition-colors flex items-center justify-center md:justify-start gap-2">
                    <ChevronRight size={14} /> {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link 
                  to="/orcamento" 
                  className="text-gray-400 font-normal hover:text-white transition-colors flex items-center justify-center md:justify-start gap-2"
                  onClick={() => trackWhatsAppClick("Orçamento", "/orcamento", "footer")}
                  data-gtm-event="whatsapp_click"
                  data-conversion="whatsapp"
                  data-button-location="footer"
                >
                  <ChevronRight size={14} /> Orçamento
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-lg mb-8 uppercase tracking-wider text-accent">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-start justify-center md:justify-start gap-3 text-gray-400">
                <Phone size={20} className="text-primary shrink-0" />
                <a href="tel:+5521992698354" className="hover:text-white transition-colors">(21) 99269-8354</a>
              </li>
              <li className="flex items-start justify-center md:justify-start gap-3 text-gray-400 group">
                <a 
                  href={whatsappUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="flex items-center gap-3 hover:text-white transition-colors"
                  onClick={() => trackWhatsAppClick("(21) 99269-8354", whatsappUrl, "footer")}
                  data-gtm-event="whatsapp_click"
                  data-conversion="whatsapp"
                  data-button-location="footer"
                >
                  <WhatsAppIcon className="w-5 h-5 text-primary shrink-0" />
                  <span>(21) 99269-8354</span>
                </a>
              </li>
              <li className="flex items-start justify-center md:justify-start gap-3 text-gray-400">
                <Camera size={20} className="text-primary shrink-0" />
                <span>@stopsomrj</span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-lg mb-8 uppercase tracking-wider text-accent">Endereço</h4>
            <div className="space-y-4">
              <a 
                href="https://maps.google.com/?q=Rua+Itatinga,+511+Duque+de+Caxias+RJ" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 leading-relaxed hover:text-white transition-colors block"
              >
                Fábrica: Rua Itatinga, 511<br />
                Duque de Caxias - RJ
              </a>
              <p className="text-gray-400 text-sm">
                <span className="text-accent font-bold uppercase tracking-widest text-[10px] block mb-1">Área de atendimento</span>
                Rio de Janeiro - RJ
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-12 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-gray-500 text-sm">© {new Date().getFullYear()} STOP SOM — Janelas Acústicas. Todos os direitos reservados.</p>
          <div className="flex gap-6">
            <Link to="/politica-de-privacidade" className="text-gray-500 hover:text-white transition-colors text-sm">Política de Privacidade</Link>
            <Link to="/termos-de-uso" className="text-gray-500 hover:text-white transition-colors text-sm">Termos de Uso</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};